"use client"

import { useEffect, useRef, useState } from "react"
import { ChevronDown } from "lucide-react"

interface Option {
    value: string
    label: string
}

interface Props {
    value: string
    onChange: (value: string) => void
    options: Option[]
    className?: string
    placeholder?: string
}

// Dropdown customizado (mesmo padrão visual do "Ordenar" já usado no app),
// para evitar o <select> nativo do navegador, que estava vindo cortado
// por causa de algum CSS global do projeto.
export default function BriefingSelect({ value, onChange, options, className = "", placeholder = "Selecionar" }: Props) {
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
        }
        document.addEventListener("click", handler)
        return () => document.removeEventListener("click", handler)
    }, [])

    const selected = options.find((o) => o.value === value)

    return (
        <div ref={ref} className={`relative ${className}`}>
            <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setOpen((o) => !o) }}
                className="w-full flex items-center justify-between gap-2 rounded-md border border-white/10 bg-secondary px-3 py-2 text-sm text-primary hover:border-white/25 transition-colors"
            >
                <span className="truncate">{selected?.label || placeholder}</span>
                <ChevronDown className="h-3.5 w-3.5 text-primary/50 flex-shrink-0" />
            </button>
            {open && (
                <div className="absolute left-0 right-0 top-full mt-1 z-30 max-h-56 overflow-y-auto rounded-lg border border-white/10 bg-background shadow-xl">
                    {options.map((o) => (
                        <button
                            type="button"
                            key={o.value}
                            onClick={(e) => { e.stopPropagation(); onChange(o.value); setOpen(false) }}
                            className={`w-full text-left px-3 py-2 text-sm transition-colors hover:bg-white/5 ${o.value === value ? "text-blue-400 font-medium" : "text-primary/80"}`}
                        >
                            {o.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}
